<template>
    <div>
        <tab name="3"></tab>
        <div class="page-filter-box">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="产品ID" :value="1"></el-option>
                            <el-option label="订单ID" :value="2"></el-option>
                            <el-option label="订单编号" :value="3"></el-option>
                            <el-option label="购买人ID" :value="4"></el-option>
                            <el-option label="支付平台交易号" :value="5"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
				    <el-select v-model="params.handleStatus" placeholder="请选择" size="small">
				        <el-option label="不限制处理状态" value=""></el-option>
				        <el-option label="只看已处理" :value="1"></el-option>
				        <el-option label="只看未处理" :value="0"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.dateType" slot="prepend" placeholder="请选择">
                                <el-option label="下单时间" :value="1"></el-option>
                                <el-option label="支付时间" :value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/activityRepeatOrder/export')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-download" size="small" @click="download" :loading="downLoading">导出订单</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column type="expand" label="展开">
                    <template slot-scope="props">
                        <div v-for="(item,index) in props.row.recordDetail" :key="index">
                            <span><span class="color-info">{{item.payPlatformCodeName }}交易号:</span> {{item.outTradeNo}}</span>
                            <span class="ML20"><span class="color-info">{{item.payPlatformCodeName}}支付时间: </span>{{item.successTime}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="业务" prop="orderType">
                    <template slot-scope="scope">{{orderType[scope.row.orderType]}}</template>
                </el-table-column>
                <el-table-column prop="paymentStatus" label="支付状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.paymentStatus == 1">未支付</span>
                        <span v-else-if="scope.row.paymentStatus == 2" class="color-success">已支付</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orderStatus" label="订单状态">
                    <template slot-scope="scope">
                       {{orderStatus.get(scope.row.orderStatus)}}
                    </template>
                </el-table-column>
                <el-table-column prop="orderId" label="订单ID" min-width="90"></el-table-column>
                <el-table-column prop="sn" label="订单编号" min-width="140"></el-table-column>
                <el-table-column prop="customerId" label="购买人ID"></el-table-column>
                <el-table-column prop="createTime" label="下单时间" min-width="150"></el-table-column>
                <el-table-column prop="totalAmountStr" label="总价"></el-table-column>
                <el-table-column prop="totalDiscountAmountStr" label="优惠"></el-table-column>
                <el-table-column prop="realPayAmountStr" label="实际支付"></el-table-column>
                <el-table-column prop="refundPlatform" label="退款渠道" show-overflow-tooltip></el-table-column>
                <el-table-column prop="refundPlatformSn" label="退款渠道交易号" show-overflow-tooltip min-width="150"></el-table-column> 
                <el-table-column prop="refundTime" label="退款渠道支付时间" show-overflow-tooltip min-width="150"></el-table-column> 
                <el-table-column prop="goodId" label="产品ID"></el-table-column>
                <el-table-column prop="goodName" label="产品名称" show-overflow-tooltip min-width="250">
                    <template slot-scope="scope">
                        <el-link class="ellipsis" :href="`${sswap}/pages/activity/detail/detail?activityId=${scope.row.goodId}`" target="_blank">{{scope.row.goodName}}</el-link>
                    </template>
                </el-table-column>
				<el-table-column prop="balanceTypeName" label="是否投资" min-width="150"></el-table-column>
				<el-table-column prop="handleStatus" label="处理状态" min-width="150">
					<template slot-scope="scope">
					    <span v-if="scope.row.handleStatus == 1">已处理</span>
					    <span v-else-if="scope.row.handleStatus == 0" class="color-success">未处理</span>
					</template>
				</el-table-column>
				<el-table-column prop="handleUserName" label="处理人" min-width="150"></el-table-column>
				<el-table-column prop="handleTime" label="处理时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="70">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/activityRepeatOrder/detail')"
                            type="text"
                            size="small"
                            icon="el-icon-coordinate"
                            @click="edit(scope.row.id)"
                            >处理</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
import Tab from '../../components/tab.vue';
const defaultParams = {
    pageNo:1,
    searchType: 1,
    searchValue: '',
    dateType: 1,
    startTime:'',
    endTime:'',
	handleStatus:0
}
export default {
    components:{Tab},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                dateType: parseInt(this.$route.query.dateType || 1),
                startTime:this.$route.query.startTime || '',
                endTime:this.$route.query.endTime || '',
				handleStatus:parseInt(this.$route.query.handleStatus || 0),
				
            },
            datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
            listLoading: true,
            downLoading:false,
            sswap:process.env.VUE_APP_SSWAP_URL,
            orderType: {
                1: '演出',
                2: '众筹',
                3: '周边',
				7: '演出会员'
            },
        }
    },
    computed:{
        orderStatus(){
            return new Map([
                [1,'待支付'],
                [2,'待发货'],
                [3,'部分发货'],
                [4,'已发货'],
                [5,'已完成'],
                [6,'已过期'],
                [7,'已取消']
            ])
        },
        
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                startTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || ''
            }
            this.$request({
                url: "/activityRepeatOrder/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //导出订单
        async download(){
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url:'/activityRepeatOrder/export',
                method: 'post',
                data: {
                    ...this.params
                },
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'重复支付订单.'+this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
        //编辑事件
        edit(id){
            this.$router.push({
                path: `/finance/statement/repeatOrder/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params
                        }
                    ),
                },
            });
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__expanded-cell{
    div{
        line-height: 30px;
        color: $--color-font-normal;
    }
}
</style>